import {legacy_createStore as createStore, applyMiddleware, combineReducers, compose} from 'redux';
import thunkMiddleware from 'redux-thunk';
import {notificationState} from './reducers/notification.reducers';
import {viewState} from './reducers/view.reducers';
import {narrativeBoardState} from './reducers/narrative-board.reducers';
import {cardLibraryState} from './reducers/card-library.reducers';
import {pvpLibraryState} from './reducers/pvp-library.reducers';

declare global {
    interface Window {
      __REDUX_DEVTOOLS_EXTENSION_COMPOSE__? : typeof compose;
    }
}

const composeEnhancers = (typeof window !== 'undefined' &&
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

/**
* configure application store
*/
export default function configureStore() {
  const rootReducer = combineReducers({
    notificationState,
    viewState,
    narrativeBoardState,
    cardLibraryState,
    pvpLibraryState,
  });
  return createStore(
      rootReducer,
      // preloadedState,
      composeEnhancers(
          applyMiddleware(thunkMiddleware),
      ),
  );
}
